import type { ILogTransport } from '../types';

export const combineTransports = (...transports: ILogTransport[]): ILogTransport => ({
  push(log) {
    transports.forEach((transport) => {
      transport.push(log);
    });
  },
});
